import { render, staticRenderFns } from "./ProExpirationBanner.vue?vue&type=template&id=449fdf78&scoped=true"
import script from "./ProExpirationBanner.vue?vue&type=script&lang=js"
export * from "./ProExpirationBanner.vue?vue&type=script&lang=js"
import style0 from "./ProExpirationBanner.vue?vue&type=style&index=0&id=449fdf78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449fdf78",
  null
  
)

export default component.exports